import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../../components/GeoProvider'
import ErrorMessage from '../../../components/Layout/ErrorMessage'
import Spinner from '../../../components/Loader/Spinner'
import EmptyMap from '../../../components/Map/emptyMap'
import Map from '../../../components/Map'
import toolTipFormatter from '../toolTipFormatter'
import VulMapLegend from '../birthtrendMapLegendHorizontal'
import SideTable from './SideTable'
import styles from './MapPage.module.scss'
import dayjs from 'dayjs'
import ErrorLogs from '../../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../../components/AuthProvider'
import DisplayDateProvider from '../../../components/DisplayDateProvider/DisplayDateProvider'
import Timeline from '../../../components/Timeline'

const DashboardMap = ({ geo_type, geo_parent, zoomLocation }) => {
  let getCategoryState=window.localStorage.getItem('bt_category')

  const { user } = useAuthState()
  const chartRef = useRef(null)
  const location = useLocation()
  const hash = location.hash
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  const slotString = 'week'
  const [getMapStates, setMapStates] = useState()
  const [metros, setMetros] = useState()
  const [activeCbsa, setActiveCbsa] = useState()
  const [getStats, setStats] = useState()
  const [errorCode, setErrorCode] = useState()
  // const [getMedicalFactorData, setMedicalFactorData] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getCBSAJsonData, setCBSAJsonData] = useState()
  const [getStateJson, setStateJson] = useState()
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
     isChecked,
     locationName,
     displayDate,
     setDisplayDate,
     setIsChecked,
      getTrimesterState,
      getAgeState,
      getComorbState
  } = useGeoState()

  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }


  useEffect(() => {
      fetch(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getactivelocations`,
          {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
              requester: JSON.stringify(window.localStorage.getItem('requester')),
            },
            body: JSON.stringify({
              start_date:dataStartDate,
              end_date:dataEndDate,
              geo_type:'COUNTY',
              geo_parent:geo_parent
            }),
            withCredentials: true,
            credentials: 'include',
          }
        )
          .then((response) => response.json())
          .then((resData)=>{
             seterrorOccured(false)
            if (resData !== null && resData !== undefined) {
              if (resData.status === 200) {
                setActiveCbsa(resData.data)
              }
              else{
                  setErrorCode(resData.status)
                  setErrorMessage(resData.message)
                  setErrorSubject(resData.subject)
                  seterrorOccured(true)
              }
             
            }
          }).catch((err) => {
              seterrorOccured(true)
            })},[1])

useEffect(() => {
    fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getdashmap`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            requester: JSON.stringify(window.localStorage.getItem('requester')),
          },
          body: JSON.stringify({
            start_date:dataStartDate,
            end_date:dataEndDate,
            geo_type:'STATE',
            trimester_ids:getCategoryState==="2"?'NA':getTrimesterState.value,
            age_group_ids:getAgeState.value,
            comorb_ids:getComorbState.map(item => item.value).sort().join(','),
            category_ids:getCategoryState
          }),
          withCredentials: true,
          credentials: 'include',
        }
      )
        .then((response) => response.json())
        .then((resData)=>{
        
          if (resData !== null && resData !== undefined) {
            if (resData.status === 200) {
              if(Object.keys(resData.data.results).length===0)
                {
                   setErrorCode(resData.status)
                  setErrorMessage(resData.message)
                  setErrorSubject(resData.subject)
                  seterrorOccured(true)
                }
                else
                {
                    seterrorOccured(false)
                  var datacount= Object.keys(resData.data.results).length-1 
                  setDisplayDate(Object.keys(resData.data.results).sort()[datacount])
                  setMapStates(resData.data.results)
                }
             
            }
            else{
                setErrorCode(resData.status)
                setErrorMessage(resData.message)
                setErrorSubject(resData.subject)
                seterrorOccured(true)
            }
           
          }
        }).catch((err) => {
            seterrorOccured(true)
          })},[1,getTrimesterState,getAgeState,getComorbState,getCategoryState])


useEffect(() => {
    fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getdashmap`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            requester: JSON.stringify(window.localStorage.getItem('requester')),
          },
          body: JSON.stringify({
            start_date:dataStartDate,
            end_date:dataEndDate,
            geo_type:'FIPS',
            geo_parent:geo_parent,
            trimester_ids:getCategoryState==="2"?'NA':getTrimesterState.value,
            age_group_ids:getAgeState.value,
            comorb_ids:getComorbState.map(item => item.value).sort().join(','),
            category_ids:getCategoryState
          }),
          withCredentials: true,
          credentials: 'include',
        }
      )
        .then((response) => response.json())
        .then((resData)=>{
          
          if (resData !== null && resData !== undefined) {
            if (resData.status === 200) {
              if(Object.keys(resData.data.results).length===0)
                {
                   setErrorCode(resData.status)
                  setErrorMessage(resData.message)
                  setErrorSubject(resData.subject)
                  seterrorOccured(true)
                }
                else
                {
                   seterrorOccured(false)
               var datacount= Object.keys(resData.data.results).length-1 
                let dd= Object.values(resData.data.results)[datacount]
                    let mappedMSAData = Object.entries(dd).map((state) => {
                    let name = state[1].geo_name
                    return { ...state[1], name: name, identifier: name }
                     })
                setStats(mappedMSAData)
                setMetros(resData.data.results)
                }
            }
            else{
                setErrorCode(resData.status)
                setErrorMessage(resData.message)
                setErrorSubject(resData.subject)
                seterrorOccured(true)
            }
           
          }
        }).catch((err) => {
            seterrorOccured(true)
          })},[1,getTrimesterState,getAgeState,getComorbState,getCategoryState])

  useEffect(() => {
    let url = `${window.location.origin}/birthtrend/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])
  useEffect(() => {
    let url = `${window.location.origin}/birthtrend/county.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setCBSAJsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file us_hrr_values ')
      })
  }, [1])
  if (errorOccured) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorCode === 404 ? `for ${geo_parent}` : errorMessage}
      />
    )
  }

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.cbsasPanel}`}>
        <>
          {regionSelected === 'fips' && (
            <>
              {getStats !== undefined && activeCbsa !== undefined ? (
                <SideTable
                  stateData={getStats}
                  chartRef={chartRef}
                  geo_parent={geo_parent}
                  geo_id={zoomLocation}
                  activeCbsasData={activeCbsa}
                />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
        </>
      </div>
      <div className={`${styles.map}`}>
        {regionSelected === 'fips' && (
          <>
            {metros !== undefined &&
            getMapStates !== undefined &&
            activeCbsa !== undefined &&
            getCBSAJsonData ? (
              <>
               <div className={`${styles.providerHeader}`}>
               <DisplayDateProvider
                textShow={'Insights for '}
                showWeek={false}
                lastweekEndDate={displayDate}
                dashType={'BIRTHTREND'}
                      />
                   <Timeline
                      statesData={getMapStates}
                      latestPositionString={latestPositionString}
                      slotString={slotString}
                      slotTimeInSeconds={slotTimeInSeconds}
                      markCounts={12}
                      dashboardType={'BIRTHTREND'}
                  />
               </div>
               <div className={styles.legendDiv}>
                <VulMapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={activeCbsa}
                  statesData={getMapStates}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="countymapmsa"
                  enableButtons={true}
                  zoomLocation={zoomLocation}
                  chartRef={chartRef}
                  mapDataType={0}
                  stateJson={getStateJson}
                  dashboardType="birthtrend"
                  cbsaData={null}
                    countyData={metros}
                    countyGeoJson={getCBSAJsonData}
                    showCountyLabels={true}
                />
              
              </>
            ) : (
              <EmptyMap />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default DashboardMap
